export default __webpack_public_path__ + "static/media/GetPricing.750b4a02.png";